import { Link, Params } from "react-router";
import EventTimetable from "@/components/EventTimetable";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import ErrorPage from "@/pages/_error";
import { graphql, Environment } from "react-relay";
import { preload, usePreloaded } from "@/utils/relay";
import { EventTimetablePageQuery as EventTimetablePageQueryType } from "./__generated__/EventTimetablePageQuery.graphql";
export default function EventTimetablePage() {
  const {
    query: { eventBySlug },
  } = useEventTimetablePageQuery();
  const intl = useIntl();
  if (!eventBySlug) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage({ defaultMessage: "Event not found" })}
      />
    );
  }
  return (
    <>
      <div className="flex flex-col gap-3">
        {eventBySlug.viewerCanUpdateAgenda && (
          <Link to={"edit"} relative="route" className="flex justify-end mb-3">
            <FormattedMessage defaultMessage="Edit" />
          </Link>
        )}
        {eventBySlug.agenda ? (
          <EventTimetable timetable={eventBySlug} />
        ) : (
          <p className="text-gray-400">
            <FormattedMessage defaultMessage="The agenda has not been defined." />
          </p>
        )}
      </div>
    </>
  );
}
const EventTimetablePageQuery = graphql`
  query EventTimetablePageQuery($slug: String!) {
    eventBySlug(slug: $slug) {
      id
      title
      viewerCanUpdateAgenda: viewerCan(action: UPDATE_AGENDA)
      agenda
      ...EventTimetableFragment
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug } }: { params: Params<string> }) => {
    if (!slug) {
      throw new Response("No slug", { status: 500 });
    }
    return preload<EventTimetablePageQueryType>(
      environment,
      EventTimetablePageQuery,
      { slug },
    );
  };
};
const useEventTimetablePageQuery = () =>
  usePreloaded<EventTimetablePageQueryType>();

export const lazyHandle = {
  titleI18n: defineMessage({ defaultMessage: "Agenda" }),
};
